<div *ngIf="data?.errorData?.isDuplicate" class="px-0 container-fluid  container-box">
  <div class="row justify-content-center px-0 mx-0">
    <div class="col-12 px-0">
      <app-common-duplicate-tab  
      [data]="data?.errorData" 
      [potentialError]="potentialError" 
      [importError]="importError"
      (navToError)="reloadData($event)">
    </app-common-duplicate-tab>
    </div>
  </div>
  </div>
  <div *ngIf="!data?.errorData?.isDuplicate" class="container-fluid  container-box">
    <div class="row justify-content-center">
      <div class="col-12 px-0">
        <div  *ngIf="data?.errorData?.importError" [style]="{'height': flexHeight}">
          <div class="row">
            <div class="">
              <div class="d-flex justify-content-center  justify-content-md-start">
                <span class="text-semi-primary no-error">No errors detected.</span>
            </div>
          </div>
         </div>
        </div>
        <app-ag-grid 
          class="center-Pagination d-block position-relative minHeightSet"
          [ngStyle]="{'height': flexHeight}" 
          [dataModel]="dataModel" 
          [rowData]="data?.errorData?.rowData"
          [paginations]="false"
          [columnSettings]="false"
          (gridReady)="onGridReady($event)">
        </app-ag-grid>
      <app-custom-loader *ngIf="!data?.errorData?.importError" class="position-absolute top-50 start-50 translate-middle" style="z-index: 6;" [isLoaderLoading]="isLoading"></app-custom-loader>
      </div>
    </div>
  </div>
  